import { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import { ChatContextType, ChatHintType } from '@trinity/chat';
import type { Chat } from '@trinity/chat';
import {
  ActiveChatSessionContext,
  ChatHintsContext,
  ChatHintsLoadingContext,
  ChatInitialMessageContext,
} from './context';
import { useGroupId } from '@trinity/chat-components/containers/Chat/selectors';

type Props = {
  children: React.ReactNode;
};

export const ChatHintsContainer = (props: Props) => {
  const chat = useContext(ActiveChatSessionContext);
  const brandIdentifier = useActiveBrandIdentifier();
  const groupId = useGroupId();
  const client = useChatApiClient();

  const query = useQuery({
    queryKey: ['chat-hints', chat.context, brandIdentifier],
    queryFn: () => {
      return client.chat.getChatInitialMessage({
        context: chat.context,
        brandIdentifier,
      });
    },
    initialData: {
      hints: [],
      message: '',
    },
  });

  const loading = useMemo(() => {
    return query.isLoading;
  }, [query.isLoading]);

  return (
    <ChatInitialMessageContext.Provider value={query.data.message}>
      <ChatHintsContext.Provider value={query.data.hints}>
        <ChatHintsLoadingContext.Provider value={loading}>
          {props.children}
        </ChatHintsLoadingContext.Provider>
      </ChatHintsContext.Provider>
    </ChatInitialMessageContext.Provider>
  );
};